import { FC } from 'react'
import { ReactComponent as MyProtectIcon } from './img/protect.svg'
import IconWrapper, { IconWrapperProps } from './IconWrapper'

type ProtectIconProps = IconWrapperProps

export const ProtectIcon: FC<ProtectIconProps> = ({ className, ...props }) => {
  return (
    <IconWrapper className={className} {...props}>
      <MyProtectIcon />
    </IconWrapper>
  )
}
